import {Component, Input, OnInit} from '@angular/core';
import { FormControl } from '@angular/forms';
import {map, Observable, startWith, switchMap} from 'rxjs';
import { Field, ObservableField } from '../../detail/detail.service';

@Component({
    selector: 'cml-autocomplete-control',
    templateUrl: './cml-autocomplete-control.component.html',
    styleUrls: ['./cml-autocomplete-control.component.scss'],
    standalone: false
})
export class CmlAutocompleteControlComponent implements OnInit {
  _formControl!: FormControl;
  get formControl(): FormControl {
    return this._formControl;
  }
  @Input() set formControl(value: FormControl) {
    this._formControl = value;
    this.initValue();
  }
  @Input()
  errorMessage!: string

  @Input()
  field!: Field;

  filtered$: Observable<any[]> | undefined;

  observableField!: ObservableField;

  initialized: boolean = false;

  constructor() {
  }

  ngOnInit() {
    if (this.field.observable) {
      this.observableField = this.field.observable;
    }
    this.initValue();
  }

  async initValue() {
    this.filtered$ = this.formControl.valueChanges
      .pipe(
        startWith(''),
        switchMap(value => (value ? this._filter(value) : this.observableField.observable))
    );

    if (this.field && this.field.observable && this.formControl.value != null) {
      await this.setValueToField()
    }
    this.initialized = true;
  }

  async setValueToField() {
    let values = await this.field.observable!.observable.toPromise();
    let idName = this.field.observable!.optionValue;
    const unqVal = values.find((x: any) =>  x[idName] === this.formControl.value)
    if(unqVal) {
      this.formControl.setValue(unqVal)
    }
  }
  async onBlurHandler() {
    const inpValue = this.formControl.value;
    if (!inpValue) return;

    let values = await this.field.observable!.observable.toPromise();
    let idName = this.field.observable!.optionValue;
    let displayValue = this.observableField.optionName;

    let requiredValue: any;
    if (typeof inpValue === 'string') {
      requiredValue = inpValue
    } else if (typeof inpValue === 'object') {
      requiredValue = inpValue[idName]
    }
    const unqVal = values.find((x: any) => x[idName] === requiredValue || x[displayValue] === requiredValue);

    if (unqVal) {
      this.formControl.setErrors(null);
      this.formControl.setValue(unqVal);
    } else if (this.initialized) {
      this.formControl.setErrors({ notFoundInList: true });
    }
  }

  get getDisplayValue() {
    return (option: any) => {
      if (option && this.field && this.field.observable) {
        return option[this.field.observable.optionName];
      }
      return '';
    };
  }

  private _filter(value: any): Observable<any[]> {
    let fieldName = this.observableField.optionName;
    let filterValue = typeof value === 'string' ? value.toLowerCase() : value[fieldName];

    return this.observableField.observable.pipe(
      map((els: any[]) => els.filter(el => el[fieldName].toLowerCase().includes(filterValue.toLowerCase())))
    );
  }
}
